import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../../app/_services/app.service';
import { CommonService } from '../../../../app/_services/common.service';
import { EwayBillService } from '../../services/EwayBill/eway-bill.service';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { OrdersService } from '../../services/orders/orders.service';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../../app/auth/_services/encrypt-decrypt.pipe';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-extend-eway-bill',
  templateUrl: './extend-eway-bill.component.html',
  styleUrls: ['./extend-eway-bill.component.scss']
})
  // Added by priya - 10/02/2026 - cn(PRIYA-JAN26-017)
export class ExtendEwayBillComponent implements OnInit {

  static that: ExtendEwayBillComponent;
  @Output() onCloseEvent = new EventEmitter<any>();
  @Input() data: any = {};
  CompanyGSTIN: any;
  CompanyId: any;
  userId: any;
  TenantId: any;
  hasEditAccess: Boolean = true;
  isFormSubmit: boolean = false;
  EwayConsignmentList: any = [];
  isEwayFormSubmit: boolean = false;
  EwayValidityData: any = {};
  EwayDistance = {
    lable: 'Remaining Distance',
    formControlName: 'EwayDistance',
    dataField: 'EwayDistance',
    isRequired: true,
    type: 'number',
    placeholder: 'Enter Remaining Distance',
  };
  EwayReason: any = {
    lable: 'Extend Validity Reason',
    formControlName: 'EwayReason',
    dataField: 'EwayReason',
    isRequired: true,
    placeholder: 'Select Reason',
    isSearchByApi: false,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  EwayRemark = {
    lable: 'Extend Remark',
    formControlName: 'EwayRemark',
    dataField: 'EwayRemark',
    isRequired: true,
    type: 'textarea',
    placeholder: 'Enter Extend Remark',
  };

  constructor(
    private orderService: OrdersService,
    private _appService: appService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private Eway: EwayBillService,
    private mobileDetectionService: MobileDetectionService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private translate: TranslateService,
  ) {
    ExtendEwayBillComponent.that = this;
  }

  ngOnInit() {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.CompanyGSTIN = JSON.parse(localStorage.getItem('ChnageCompnayId')).SelectedCompantGSTIN;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.hasEditAccess = this.commonService.CheckHasRight('EDIT', 'NETWORK_DETAILS');
    this.TenantId = JSON.parse(localStorage.getItem("ChnageCompnayId")).TenantId;
    this.GetEwayLrData(this.data.BookingId, this.data.ConsignmentDetailId)
    this.GetValidityReason();
  }

  GetEwayLrData(BookingId, ConsignmentDetailId) {
    this.Eway.GetEwayLrData(BookingId, ConsignmentDetailId).then(data => {
      if (data) {
        this.EwayConsignmentList = data;
      }
    })
    .catch(err => {
      console.error(err);
    });
  }

  GetValidityReason() {
    this.Eway.GetValidityReason().then(data => {
      if (data.length > 0) {
        this.EwayReason.dropdownList = data || [];
      }
    })
  }

  getEwayChangedValue(value, data) {
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if (data.dataField == 'EwayReason') {
      let selectedItem = data.dropdownList.find(item => item.value === value);
      this.EwayValidityData[data.dataField] = newValue;
      this.EwayValidityData.EwayReasonName = selectedItem.name;
    } else if (newValue) {
      this.EwayValidityData[data.dataField] = newValue;
    }
  }

  ExtendEwayValidity() {
    this.isEwayFormSubmit = true;
    if (this.ValidateEwayFieldData()) {
      this.EwayConsignmentList[0].RemainingDistance = this.EwayValidityData.EwayDistance;
      this.EwayConsignmentList[0].ValidityReason = this.EwayValidityData.EwayReasonName;
      this.EwayConsignmentList[0].ExtendRemarks = this.EwayValidityData.EwayRemark;
      this.EwayConsignmentList[0].eway_bill_number = this.data.EwayBillNo;
      this.EwayConsignmentList[0].vehicle_number = this.data.VehicleNo;
      return this.Eway.ExtendEwayValidity(this.EwayConsignmentList, this.userId, this.data.BookingId, this.data.ConsignmentDetailId).then(res => {
        if (res.success) {
          this.toastr.success('EWay Bill Validity Extended Successfully!');
          this.closeEwayModal();
        } else {
          this.toastr.warning(res.errorMessage);
        }
      }).catch(err => {
        return Promise.resolve();
      });
    }
  }

  ValidateEwayFieldData() {
    var IsAllDataDone: any = true;
    if (!this.EwayValidityData.EwayDistance || this.EwayValidityData.EwayDistance === null || this.EwayValidityData.EwayDistance === undefined) {
      IsAllDataDone = false;
    }
    if (!this.EwayValidityData.EwayReason) {
      IsAllDataDone = false;
    }
    if (!this.EwayValidityData.EwayRemark) {
      IsAllDataDone = false;
    }
    if (!IsAllDataDone) {
      var RequiredError = this.translate.instant("DriverDetailsById.RequiredError");
      this.toastr.error(RequiredError, "error");
    }
    return IsAllDataDone;
  }

  closeEwayModal() {
    this.onCloseEvent.emit();
  }

}
